import IconWrap from '@/components/IconWrap';
import LoadingWrap from '@/components/LoadingWrap';
import TableAdmin from '@/components/TableAdmin';
import { DeleteBinIcon, EditIcon } from '@/assets/icons';
import { Modal, notification, Row, Space } from 'antd';
import { useCallback, useEffect } from 'react';
import { useMutation, useQuery } from 'react-query';
import { handleMessageError } from '@/util/handleMessageError';
import floorService from '@/services/floor.service';
import './style.scss';
import { appRoutes } from '@/router/routes';
import { PlusIcon } from '@/assets/icons';
import LayoutContent from '@/layout/Content';
import { useNavigate } from 'react-router-dom';

const Floor = () => {
    const navigate = useNavigate();
    const {
        isLoading,
        data: floorData,
        refetch,
    } = useQuery(['floor'], () => floorService.getAll(), {
        enabled: true,
        onError: (error: any) => {
            handleMessageError(error);
        },
    });

    const { mutate: mutateDelete } = useMutation((id: string | number) => floorService.delete(id), {
        onSuccess: (data: any) => {
            notification.success({
                message: 'XÓA THÀNH CÔNG',
            });
            refetch();
        },
        onError: (error: any) => {
            handleMessageError(error);
        },
    });

    const confirmDelete = useCallback(
        (id: string) => {
            Modal.confirm({
                title: 'Xác nhận xóa phòng',
                content: 'Bạn chắc muốn xóa phòng này chứ.',
                onOk: () => {
                    mutateDelete(id);
                },
                okText: 'Xóa',
                cancelText: 'Đóng',
            });
        },
        // eslint-disable-next-line react-hooks/exhaustive-deps
        [mutateDelete],
    );

    const column = [
        {
            title: 'Sắp xếp',
            dataIndex: 'sortOrder',
            width: 100,
            align: 'center',
        },
        {
            title: 'Tên tầng',
            dataIndex: 'name',
            align: 'left',
        },
        {
            title: 'Tác vụ',
            render: (record: any) => (
                <Row justify="center">
                    <Space size={20}>
                        <IconWrap
                            className="pointer"
                            icon={<EditIcon />}
                            onClick={() => {
                                navigate(`${appRoutes.ADMIN.ROOM.FLOOR_UPDATE}/${record._id}`);
                            }}
                        />
                        <IconWrap
                            className="pointer"
                            onClick={() => confirmDelete(record._id)}
                            icon={<DeleteBinIcon />}
                        />
                    </Space>
                </Row>
            ),
            width: 150,
        },
    ];

    return (
        <LayoutContent
            className="p-floor"
            actionHeader={[
                {
                    url: `${appRoutes.ADMIN.ROOM.FLOOR_ADD}`,
                    title: 'THÊM MỚI',
                    icon: <PlusIcon />,
                },
            ]}
            title={`QUẢN LÝ TẦNG`}
        >
            <LoadingWrap isLoading={isLoading}>
                <div className="p-main">
                    <TableAdmin
                        columns={column}
                        data={floorData?.data ?? []}
                        bordered
                        rowKey="_id"
                        className="table_floor"
                    />
                </div>
            </LoadingWrap>
        </LayoutContent>
    );
};

export default Floor;
